import React, {useState, useEffect, useRef} from 'react'
import HeadingArea from '../../general/HeadingArea'
import ResponseMsg2 from '../../general/ResponseMsg2'
import { AiOutlineSearch } from 'react-icons/ai';
import { FaPrint } from 'react-icons/fa';


const ClassTimeTable = ({setLoading}) => {
            const [response2, setResponse2] = useState({ message: '', status: 'success' });
        const [classes, setClasses] = useState([]);
      const [availableSections, setAvailableSections] = useState([]);
   const [selectedClassId, setSelectedClassId] = useState('');
const [selectedSection, setSelectedSection] = useState('');
const [timeTable, setTimeTable] = useState([]);
const printRef = useRef(null);

                 const fetchClasses = async () => {
                           setLoading(true);
                   try {
                       const response = await fetch('https://api.kcian.in/get-classes');
       
                       if (response.ok) {
                           const data = await response.json();
                           setClasses(data);
                           setLoading(false);

                       } else {
                           setLoading(false);
                           console.error('Failed to fetch class');
                       }
                   } catch (error) {
                       setLoading(false);
                       console.error('Error fetching data:', error);
                   }
     }

     
          useEffect(() => {
       fetchClasses();
     }, []);
     
     
     useEffect(() => {
       if (selectedClassId) {
     const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
     
         if (selectedClass && selectedClass.sections) {
           const sectionArray = selectedClass.sections
             .split(',')
             .map((s) => s.trim()) 
             .filter((s) => s !== '');
     
           setAvailableSections(sectionArray);
         } else {
           setAvailableSections([]);
         }
     
         setSelectedSection('');
       }
     }, [selectedClassId, classes]);


const fetchTimeTable = async () => {
  if (!selectedClassId || !selectedSection) {
    setResponse2({ message: 'Please select both class and section.', status: 'error' });
    return;
  }

  setLoading(true);

        const params = new URLSearchParams();
      params.append('classId', selectedClassId);
      params.append('section', selectedSection);


  try {
    const response = await fetch(
      `https://api.kcian.in/get-class-time-table?${params.toString()}`
    );

    if (response.ok) {
      const data = await response.json();
      setTimeTable(data);
      setResponse2({ message: 'Time Table Fetched Successfully!', status: 'success' });
    } else {
      const errorData = await response.json();
                 setResponse2({ message: errorData.message || 'Something Went Wrong. Please try again.', status: 'error' });
                 setTimeTable([]);
    }
  } catch (error) {
    console.error('Error fetching time table:', error);
  } finally {
            setTimeout(() => {
          setResponse2('');
        }, 2000);
    setLoading(false);
  }
};

  const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
const selectedClassName = selectedClass ? selectedClass.class_name : '';

     const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// Extract all unique periods from timeTable data
const allPeriodsSet = new Set();
timeTable.forEach(dayRow => {
  if (dayRow.periods) {
    Object.keys(dayRow.periods).forEach(periodLabel => {
      allPeriodsSet.add(periodLabel);
    });
  }
});
const allPeriods = Array.from(allPeriodsSet).sort();

// Map day name to timetable row for quick lookup
const timetableByDay = {};
timeTable.forEach(dayRow => {
  timetableByDay[dayRow.day] = dayRow;
});


  const handlePrint = () => {
    if (!timeTable.length) {
      setResponse2({ message: 'No Time Table to Print', status: 'success' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
      return;
    }
    window.print();
  };

  return (
    <>
                              <section className="py-4">
        <div className="px-4">
          <HeadingArea message1="Time Table" message2="Class Time Table" />

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


<div className='profile-card'>

              <span className="profile-heading align-content-center">Select Criteria</span>

<div className='d-md-flex d-sm-flex d-block mt-3'>

                  <div className="mb-4 w-100 me-3">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Class*</label>
                    <select
                      className="profile-input"
                      value={selectedClassId}
                      onChange={(e) => setSelectedClassId(e.target.value)}
                      required
                    >
                      <option value="">-- Select Class --</option>
                      {classes.map((cls) => (
                        <option key={cls.id} value={cls.id}>
                          {cls.class_name}
                        </option>
                      ))}
                    </select>
</div>
                  </div>

                  {/* Select Section */}
                  <div className="mb-4 w-100">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Section*</label>
<select
  className="profile-input"
  value={selectedSection}
  onChange={(e) => setSelectedSection(e.target.value)}
  required
>
  <option value="">-- Select Section --</option>
  {availableSections.map((section, idx) => (
    <option key={idx} value={section}>
      {section}
    </option>
  ))}
</select>

                    </div>
                  </div>


</div>
{/* flex ends */}

<div className='text-end'>
<button className='profile-btn2' onClick={() => fetchTimeTable()}>
  <AiOutlineSearch /> Search
</button>
</div>

</div>
{/* profile card ends */}



          <div className='profile-card mt-3'>
            
          <div ref={printRef} className='printable-area'>
            
                        <span className="profile-heading">Time Table for {selectedClassName} {selectedSection}</span>
   <div className="text-end d-print-none">
              <button
                className="profile-btn2"
                onClick={handlePrint}
                disabled={!timeTable.length}
              >
                <FaPrint /> Print
              </button>
            </div>


            <div className='table-responsive my-3'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Period</th>
{daysOfWeek.map(day => (
      <th key={day}>{day.slice(0, 3)}</th>
    ))}
    <th className='rounded-end-4'></th>
</thead>


{timeTable.length === 0 ? (
              <tr className='text-center account-tr'><td colSpan={7}>No Data found</td></tr>
            ) : (
<>
  {allPeriods.map(periodLabel => (
    <tr className='account-tr' key={periodLabel}>
      <td>Period {periodLabel}</td>
      {daysOfWeek.map(day => {
        const dayRow = timetableByDay[day];
        const subject = dayRow?.periods?.[periodLabel];
        return (
          <td key={day}>
{subject ? (
  <>
    {subject.sub_name} ({subject.sub_code}) ({subject.sub_type === 'Theory' ? 'TH' : 'P'})
  </>
) : (
  '-'
)}
          </td>
        );
      })}
    </tr>
  ))}
</>
)}

</table>
</div>

</div>
</div>


</div>
</section>

      <style>{`
@media print {

  body * {
    visibility: hidden;
  }
  .printable-area, .printable-area * {
    visibility: visible;
  }
  .printable-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    font-size: 0.8em;
  }

  .d-print-none {
    display: none !important;
  }
  .printable-area .row {
    display: flex !important;
    flex-wrap: wrap !important;
  }

}

      `}</style>

    </>
  )
}

export default ClassTimeTable
